// extracted by mini-css-extract-plugin
export default {"tel":"styles_tel__hTVmq"};